import {Pipe, PipeTransform} from '@angular/core';

/**
 * @description This pipe is used to bold the text in the template
 * @example
 * 	<span [innerHTML]="text | BoldText: query"></span>
 */
@Pipe({
	name: 'BoldText',
	standalone: true,
})
export class TemplateBolderPipe implements PipeTransform {
	transform(text: string, query: string, klass: string): string {
		if (text && query) {
			const regex = new RegExp(`(${query.replace(/\+/g, '\\+')})`, 'gi');
			return text.replace(regex, `<span class="${klass}">$1</span>`); // $1 is the first match
		}
		return text;
	}
}
